/* global bootstrap */

// This file requires the following components:
// - rentals-form
// - offcanvas

document.addEventListener('DOMContentLoaded', () => {
  const offcanvas = document.getElementById('offcanvasRentalsFormFilters');

  // Add swipe events and reset to offcanvas
  if (offcanvas) {
    const form = document.querySelector(offcanvas.getAttribute('data-target')) || offcanvas.closest('rentals-form');

    offcanvas.querySelector('.offcancas-footer [type="reset"]').addEventListener('click', () => {
      [...form.formInputs].filter((node) => !node.hasAttribute('data-dropdown')).forEach((input) => {
        input.resetOptions();
      });
    });

    offcanvas.addEventListener('swiped-right', (e) => {
      if (e.target.closest('[data-swipe-ignore]') || e.target.hasAttribute('data-swipe-ignore')) {
        return;
      }

      bootstrap.Offcanvas.getInstance(offcanvas).hide();
    });

    offcanvas.addEventListener('swiped-left', (e) => {
      if (e.target.closest('[data-swipe-ignore]') || e.target.hasAttribute('data-swipe-ignore')) {
        return;
      }

      bootstrap.Offcanvas.getInstance(offcanvas).hide();
      form.submit();
    });

    form.addEventListener('submit', () => {
      bootstrap.Offcanvas.getInstance(offcanvas)?.hide();
    });
  }
});
